module.exports = __webpack_public_path__ + "img/adv-comfort.9ad05606.png";